import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Plus, Pencil, Trash2, X, Users, CalendarDays, UserCog, Download, Upload, Link, Copy, AlertTriangle } from 'lucide-react';
import LixeiraSuperAdmin, { BotaoLixeira } from '../components/LixeiraSuperAdmin'; // PLENARIUM:LIXEIRA PLENARIUM:LIXEIRA_PEDIDOS

const VAZIO_CAMARA = { nome: '', municipio: '', estado: 'AM', logoUrl: '', roteiroSessao: '' };
const VAZIO_ADMIN  = { nome: '', email: '', senha: '' };
const BASE_URL     = 'https://app.camaradigital.online';

export default function Camaras() {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lixeiraAberta, setLixeiraAberta] = useState(false); // PLENARIUM:LIXEIRA
  const [modalCamara, setModalCamara] = useState(false);
  const [modalAdmin, setModalAdmin] = useState(false);
  const [modalLinks, setModalLinks] = useState(false);
  const [modalRestaurar, setModalRestaurar] = useState(false);
  const [modalExcluir, setModalExcluir] = useState(false);
  const [camaraParaExcluir, setCamaraParaExcluir] = useState(null);
  const [senhaExcluir, setSenhaExcluir] = useState('');
  const [excluindo, setExcluindo] = useState(false);
  const [camaraSelecionada, setCamaraSelecionada] = useState(null);
  const [admins, setAdmins] = useState([]);
  const [form, setForm] = useState(VAZIO_CAMARA);
  const [formAdmin, setFormAdmin] = useState(VAZIO_ADMIN);
  const [editandoId, setEditandoId] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [fazendoBackup, setFazendoBackup] = useState(false);
  const [backupCamaraId, setBackupCamaraId] = useState(null);
  const [restaurandoCamara, setRestaurandoCamara] = useState(false);
  const [camaraRestaurarId, setCamaraRestaurarId] = useState('');

  const ESTADOS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

  const carregar = async () => {
    setLoading(true);
    try { const r = await axios.get('/api/camaras'); setLista(r.data); }
    catch { toast.error('Erro ao carregar câmaras'); }
    finally { setLoading(false); }
  };

  useEffect(() => { carregar(); }, []);

  const abrirNova   = () => { setForm(VAZIO_CAMARA); setEditandoId(null); setModalCamara(true); };
  const abrirEditar = (c) => {
    setForm({ nome: c.nome, municipio: c.municipio, estado: c.estado, logoUrl: c.logoUrl || '', roteiroSessao: c.roteiroSessao || '' });
    setEditandoId(c.id);
    setModalCamara(true);
  };
  const abrirLinks  = (c) => { setCamaraSelecionada(c); setModalLinks(true); };
  const abrirExcluir = (c) => { setCamaraParaExcluir(c); setSenhaExcluir(''); setModalExcluir(true); };

  const copiar = (texto) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(texto);
      } else {
        const el = document.createElement('textarea');
        el.value = texto; el.style.position = 'fixed'; el.style.opacity = '0';
        document.body.appendChild(el); el.focus(); el.select();
        document.execCommand('copy'); document.body.removeChild(el);
      }
      toast.success('Link copiado!');
    } catch { toast.error('Não foi possível copiar. Copie manualmente.'); }
  };

  const salvarCamara = async (e) => {
    e.preventDefault(); setSalvando(true);
    try {
      if (editandoId) { await axios.put(`/api/camaras/${editandoId}`, form); toast.success('Câmara atualizada!'); }
      else { await axios.post('/api/camaras', form); toast.success('Câmara criada!'); }
      setModalCamara(false); carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao salvar'); }
    finally { setSalvando(false); }
  };

  const confirmarExcluir = async () => {
    if (!senhaExcluir) { toast.error('Digite a senha para confirmar!'); return; }
    setExcluindo(true);
    try {
      await axios.delete(`/api/camaras/${camaraParaExcluir.id}`, { data: { senha: senhaExcluir } });
      toast.success('Câmara removida com sucesso!');
      setModalExcluir(false); setCamaraParaExcluir(null); setSenhaExcluir(''); carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao remover câmara'); }
    finally { setExcluindo(false); }
  };

  const abrirAdmins = async (camara) => {
    setCamaraSelecionada(camara);
    try { const r = await axios.get(`/api/camaras/${camara.id}/admins`); setAdmins(r.data); }
    catch { toast.error('Erro ao carregar admins'); }
    setModalAdmin(true);
  };

  const salvarAdmin = async (e) => {
    e.preventDefault(); setSalvando(true);
    try {
      await axios.post(`/api/camaras/${camaraSelecionada.id}/admins`, formAdmin);
      toast.success('Admin criado!');
      setFormAdmin(VAZIO_ADMIN);
      const r = await axios.get(`/api/camaras/${camaraSelecionada.id}/admins`);
      setAdmins(r.data);
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao criar admin'); }
    finally { setSalvando(false); }
  };

  const excluirAdmin = async (adminId) => {
    if (!window.confirm('Remover este admin?')) return;
    try {
      await axios.delete(`/api/camaras/${camaraSelecionada.id}/admins/${adminId}`);
      toast.success('Admin removido');
      const r = await axios.get(`/api/camaras/${camaraSelecionada.id}/admins`);
      setAdmins(r.data);
    } catch { toast.error('Erro ao remover admin'); }
  };

  const fazerBackupGeral = async () => {
    if (!window.confirm('Gerar backup de todos os dados do sistema?')) return;
    setFazendoBackup(true);
    try {
      const r = await axios.get('/api/camaras/backup/exportar', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `backup-geral-${new Date().toISOString().split('T')[0]}.json`);
      document.body.appendChild(link); link.click(); link.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Backup geral gerado com sucesso!');
    } catch { toast.error('Erro ao gerar backup'); }
    finally { setFazendoBackup(false); }
  };

  const fazerBackupCamara = async (camara) => {
    if (!window.confirm(`Gerar backup da câmara "${camara.nome}"?`)) return;
    setBackupCamaraId(camara.id);
    try {
      const r = await axios.get(`/api/camaras/backup/exportar/${camara.id}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `backup-${camara.slug}-${new Date().toISOString().split('T')[0]}.json`);
      document.body.appendChild(link); link.click(); link.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`Backup de ${camara.nome} gerado!`);
    } catch { toast.error('Erro ao gerar backup da câmara'); }
    finally { setBackupCamaraId(null); }
  };

  const restaurarBackupGeral = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!window.confirm('⚠️ ATENÇÃO: Restaurar o backup irá SUBSTITUIR todos os dados atuais. Tem certeza?')) { e.target.value = ''; return; }
    try {
      const texto = await file.text();
      const backup = JSON.parse(texto);
      if (!backup.versao || !backup.dados) { toast.error('Arquivo de backup inválido!'); return; }
      toast.loading('Restaurando backup...', { id: 'restaurando' });
      await axios.post('/api/camaras/backup/restaurar', { dados: backup.dados });
      toast.success('Backup restaurado! Faça login novamente.', { id: 'restaurando', duration: 5000 });
      setTimeout(() => window.location.href = '/login/admin', 3000);
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao restaurar backup', { id: 'restaurando' }); }
    e.target.value = '';
  };

  const restaurarBackupCamara = async (e) => {
    const file = e.target.files[0];
    if (!file || !camaraRestaurarId) return;
    const camara = lista.find(c => c.id === camaraRestaurarId);
    if (!window.confirm(`⚠️ ATENÇÃO: Isso irá substituir todos os dados de "${camara?.nome}". As outras câmaras NÃO serão afetadas. Tem certeza?`)) { e.target.value = ''; return; }
    setRestaurandoCamara(true);
    try {
      const texto = await file.text();
      const backup = JSON.parse(texto);
      if (!backup.versao || !backup.dados) { toast.error('Arquivo de backup inválido!'); return; }
      if (backup.tipo !== 'camara') { toast.error('Este arquivo é um backup geral. Use a opção "Restaurar" geral.'); return; }
      toast.loading('Restaurando câmara...', { id: 'restaurando-camara' });
      await axios.post(`/api/camaras/backup/restaurar/${camaraRestaurarId}`, { dados: backup.dados });
      toast.success(`Câmara "${camara?.nome}" restaurada com sucesso!`, { id: 'restaurando-camara', duration: 4000 });
      setModalRestaurar(false); setCamaraRestaurarId(''); carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao restaurar câmara', { id: 'restaurando-camara' }); }
    finally { setRestaurandoCamara(false); e.target.value = ''; }
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) { toast.error('A imagem deve ter no máximo 2MB!'); return; }
    const reader = new FileReader();
    reader.onload = () => setForm({ ...form, logoUrl: reader.result });
    reader.readAsDataURL(file);
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Câmaras Municipais</h1>
          <p className="page-subtitle">{lista.length} câmara(s) cadastrada(s)</p>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <BotaoLixeira onClick={() => setLixeiraAberta(true)} />{/* PLENARIUM:LIXEIRA_PEDIDOS -- mostra quantos pedidos aguardam */}
          <button className="btn btn-secondary" onClick={() => setModalRestaurar(true)}>
            <Upload size={14} /> Restaurar Câmara
          </button>
          <label className="btn btn-secondary" style={{ cursor: 'pointer' }}>
            <input type="file" accept=".json" style={{ display: 'none' }} onChange={restaurarBackupGeral} />
            <Upload size={14} /> Restaurar Geral
          </label>
          <button className="btn btn-secondary" onClick={fazerBackupGeral} disabled={fazendoBackup}>
            <Download size={14} /> {fazendoBackup ? 'Gerando...' : 'Backup Geral'}
          </button>
          <button className="btn btn-primary" onClick={abrirNova}>
            <Plus size={15} /> Nova Câmara
          </button>
        </div>
      </div>

      {/* Grid de câmaras */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 14 }}>
        {loading ? (
          <div className="loading-screen" style={{ minHeight: 200 }}><div className="spinner" /></div>
        ) : lista.length === 0 ? (
          <div className="card sem-dados"><p>Nenhuma câmara cadastrada.</p></div>
        ) : lista.map(c => (
          <div key={c.id} className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {c.logoUrl && (
                  <img src={c.logoUrl} alt="Logo" style={{ width: 40, height: 40, objectFit: 'contain', borderRadius: 6, border: '1px solid var(--cinza)' }} />
                )}
                <div>
                  <h3 style={{ fontSize: '0.9rem', fontWeight: 700 }}>{c.nome}</h3>
                  <p style={{ fontSize: '0.775rem', color: 'var(--texto-suave)', marginTop: 1 }}>{c.municipio} — {c.estado}</p>
                  {c.slug && (
                    <p style={{ fontSize: '0.7rem', color: 'var(--acento)', marginTop: 2 }}>
                      🔗 /camara/{c.slug}
                    </p>
                  )}
                </div>
              </div>
              <span className={`badge ${c.ativa ? 'badge-verde' : 'badge-cinza'}`}>
                {c.ativa ? 'Ativa' : 'Inativa'}
              </span>
            </div>

            <div style={{ display: 'flex', gap: 14, marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.775rem', color: 'var(--texto-suave)' }}>
                <Users size={13} /> {c._count?.vereadores || 0} vereadores
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.775rem', color: 'var(--texto-suave)' }}>
                <CalendarDays size={13} /> {c._count?.sessoes || 0} sessões
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.775rem', color: 'var(--texto-suave)' }}>
                <UserCog size={13} /> {c._count?.admins || 0} admins
              </div>
            </div>

            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
              <button className="btn btn-secondary btn-sm" onClick={() => abrirLinks(c)}>
                <Link size={12} /> Links
              </button>
              <button className="btn btn-secondary btn-sm" onClick={() => abrirAdmins(c)}>
                <UserCog size={12} /> Admins
              </button>
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => fazerBackupCamara(c)}
                disabled={backupCamaraId === c.id}
              >
                <Download size={12} /> {backupCamaraId === c.id ? '...' : 'Backup'}
              </button>
              <button className="btn btn-secondary btn-sm" onClick={() => abrirEditar(c)}>
                <Pencil size={12} />
              </button>
              <button className="btn btn-danger btn-sm" onClick={() => abrirExcluir(c)}>
                <Trash2 size={12} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {lixeiraAberta && <LixeiraSuperAdmin onFechar={() => setLixeiraAberta(false)} />}{/* PLENARIUM:LIXEIRA */}
      {/* Modal Excluir com senha */}
      {modalExcluir && camaraParaExcluir && (
        <div className="modal-overlay" onClick={() => setModalExcluir(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420 }}>
            <div className="modal-header">
              <h2 className="modal-title" style={{ color: 'var(--reprovado)' }}>
                <AlertTriangle size={18} /> Excluir Câmara
              </h2>
              <button className="btn-modal-close" onClick={() => setModalExcluir(false)}><X size={18} /></button>
            </div>
            <div className="alert alert-danger" style={{ marginBottom: 16 }}>
              <div>
                <p style={{ fontWeight: 700 }}>Você está prestes a excluir:</p>
                <p style={{ fontSize: '0.95rem', fontWeight: 800, marginTop: 3 }}>{camaraParaExcluir.nome}</p>
                <p style={{ marginTop: 6, fontSize: '0.775rem' }}>⚠️ Esta ação é irreversível. Todos os dados serão perdidos.</p>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Digite sua senha para confirmar *</label>
              <input
                className="form-input"
                type="password"
                placeholder="Sua senha de Super Admin"
                value={senhaExcluir}
                onChange={e => setSenhaExcluir(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && confirmarExcluir()}
                autoFocus
              />
            </div>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setModalExcluir(false)}>Cancelar</button>
              <button className="btn btn-danger" onClick={confirmarExcluir} disabled={excluindo || !senhaExcluir}>
                {excluindo ? 'Excluindo...' : 'Confirmar Exclusão'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Restaurar Câmara */}
      {modalRestaurar && (
        <div className="modal-overlay" onClick={() => setModalRestaurar(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 460 }}>
            <div className="modal-header">
              <h2 className="modal-title">🔄 Restaurar Câmara</h2>
              <button className="btn-modal-close" onClick={() => setModalRestaurar(false)}><X size={18} /></button>
            </div>
            <div className="alert alert-warning">
              ⚠️ A câmara selecionada terá seus dados substituídos pelo backup. As outras câmaras <strong>não serão afetadas</strong>.
            </div>
            <div className="form-group">
              <label className="form-label">Selecione a câmara *</label>
              <select className="form-input form-select" value={camaraRestaurarId} onChange={e => setCamaraRestaurarId(e.target.value)}>
                <option value="">Escolha uma câmara...</option>
                {lista.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
            </div>
            {camaraRestaurarId && (
              <div className="form-group">
                <label className="form-label">Selecione o arquivo de backup *</label>
                <label className="btn btn-secondary" style={{ cursor: 'pointer', width: '100%', justifyContent: 'center' }}>
                  <input type="file" accept=".json" style={{ display: 'none' }} onChange={restaurarBackupCamara} disabled={restaurandoCamara} />
                  <Upload size={14} /> {restaurandoCamara ? 'Restaurando...' : 'Selecionar arquivo .json'}
                </label>
                <p style={{ fontSize: '0.72rem', color: 'var(--texto-suave)', marginTop: 5 }}>
                  Use apenas backups gerados pelo botão "Backup" de cada câmara.
                </p>
              </div>
            )}
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => { setModalRestaurar(false); setCamaraRestaurarId(''); }}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Links */}
      {modalLinks && camaraSelecionada && (
        <div className="modal-overlay" onClick={() => setModalLinks(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 540 }}>
            <div className="modal-header">
              <h2 className="modal-title">🔗 Links — {camaraSelecionada.nome}</h2>
              <button className="btn-modal-close" onClick={() => setModalLinks(false)}><X size={18} /></button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { label: '👤 Login Vereador', url: `${BASE_URL}/camara/${camaraSelecionada.slug}/login/vereador` },
                { label: '⚙️ Login Admin',    url: `${BASE_URL}/camara/${camaraSelecionada.slug}/login/admin` },
                { label: '📺 Painel TV',      url: `${BASE_URL}/camara/${camaraSelecionada.slug}/tv/[ID-DA-SESSAO]` },
              ].map(({ label, url }) => (
                <div key={label} style={{ background: 'var(--fundo)', borderRadius: 8, padding: '10px 12px' }}>
                  <p style={{ fontSize: '0.72rem', color: 'var(--texto-suave)', marginBottom: 3 }}>{label}</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <code style={{ fontSize: '0.75rem', flex: 1, wordBreak: 'break-all', color: 'var(--acento)', fontFamily: 'monospace' }}>{url}</code>
                    <button className="btn btn-secondary btn-sm" onClick={() => copiar(url)}>
                      <Copy size={12} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="modal-actions" style={{ marginTop: 14 }}>
              <button className="btn btn-secondary" onClick={() => setModalLinks(false)}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Câmara */}
      {modalCamara && (
        <div className="modal-overlay" onClick={() => setModalCamara(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">{editandoId ? 'Editar Câmara' : 'Nova Câmara'}</h2>
              <button className="btn-modal-close" onClick={() => setModalCamara(false)}><X size={18} /></button>
            </div>
            <form onSubmit={salvarCamara}>
              <div className="form-group">
                <label className="form-label">Nome da Câmara *</label>
                <input
                  className="form-input"
                  value={form.nome}
                  onChange={e => setForm({ ...form, nome: e.target.value })}
                  placeholder="Ex: Câmara Municipal de Manaus"
                  required
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Município *</label>
                  <input className="form-input" value={form.municipio} onChange={e => setForm({ ...form, municipio: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Estado *</label>
                  <select className="form-input form-select" value={form.estado} onChange={e => setForm({ ...form, estado: e.target.value })}>
                    {ESTADOS.map(e => <option key={e} value={e}>{e}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Brasão / Logo da Câmara</label>
                {form.logoUrl && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                    <img src={form.logoUrl} alt="Preview" style={{ width: 56, height: 56, objectFit: 'contain', borderRadius: 6, border: '1px solid var(--cinza)' }} />
                    <button type="button" className="btn btn-danger btn-sm" onClick={() => setForm({ ...form, logoUrl: '' })}>Remover</button>
                  </div>
                )}
                <input type="file" accept="image/*" className="form-input" onChange={handleLogoUpload} />
                <p style={{ fontSize: '0.7rem', color: 'var(--texto-suave)', marginTop: 4 }}>PNG ou JPG com fundo transparente. Máx. 2MB.</p>
              </div>
              <div className="form-group">
                <label className="form-label">Roteiro de condução da sessão</label>
                <textarea
                  className="form-input"
                  rows={14}
                  value={form.roteiroSessao}
                  onChange={e => setForm({ ...form, roteiroSessao: e.target.value })}
                  placeholder="Deixe em branco para usar o roteiro padrão do sistema."
                  style={{ fontFamily: 'monospace', fontSize: '0.78rem', lineHeight: 1.6, resize: 'vertical' }}
                />
                <p style={{ fontSize: '0.7rem', color: 'var(--texto-suave)', marginTop: 4, lineHeight: 1.6 }}>
                  O sistema troca estes marcadores pelos dados da sessão na hora de imprimir:{' '}
                  <strong>{'{{CAMARA}}'} {'{{MUNICIPIO}}'} {'{{SESSAO}}'} {'{{DATA}}'} {'{{HORA}}'} {'{{SAUDACAO}}'} {'{{DESPEDIDA}}'} {'{{PRESIDENTE}}'} {'{{PRESENTES}}'} {'{{AUSENTES}}'} {'{{QUORUM}}'} {'{{PAUTAS}}'} {'{{ATA_ANTERIOR}}'} {'{{BLOCO_ATA}}'} {'{{BLOCO_AUSENCIA}}'} {'{{ORDEM_ABERTURA}}'} {'{{BLOCO_PAUTAS}}'} {'{{ORADORES}}'}</strong>.
                  {' '}Em branco, o sistema usa o roteiro padrão.
                </p>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModalCamara(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Admins */}
      {modalAdmin && camaraSelecionada && (
        <div className="modal-overlay" onClick={() => setModalAdmin(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 540 }}>
            <div className="modal-header">
              <h2 className="modal-title">Admins — {camaraSelecionada.nome}</h2>
              <button className="btn-modal-close" onClick={() => setModalAdmin(false)}><X size={18} /></button>
            </div>
            <div style={{ marginBottom: 18 }}>
              {admins.length === 0 ? (
                <p style={{ color: 'var(--texto-suave)', fontSize: '0.825rem', textAlign: 'center', padding: '14px 0' }}>
                  Nenhum admin cadastrado.
                </p>
              ) : admins.map(a => (
                <div key={a.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 0', borderBottom: '1px solid var(--cinza)' }}>
                  <div>
                    <p style={{ fontWeight: 600, fontSize: '0.825rem' }}>{a.nome}</p>
                    <p style={{ fontSize: '0.75rem', color: 'var(--texto-suave)' }}>{a.email}</p>
                  </div>
                  <button className="btn btn-danger btn-sm" onClick={() => excluirAdmin(a.id)}>
                    <Trash2 size={13} />
                  </button>
                </div>
              ))}
            </div>
            <div style={{ borderTop: '1px solid var(--cinza)', paddingTop: 14 }}>
              <h3 style={{ fontSize: '0.875rem', fontWeight: 700, marginBottom: 12 }}>Adicionar Admin</h3>
              <form onSubmit={salvarAdmin}>
                <div className="form-group">
                  <label className="form-label">Nome *</label>
                  <input className="form-input" value={formAdmin.nome} onChange={e => setFormAdmin({ ...formAdmin, nome: e.target.value })} required />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div className="form-group">
                    <label className="form-label">E-mail *</label>
                    <input className="form-input" type="email" value={formAdmin.email} onChange={e => setFormAdmin({ ...formAdmin, email: e.target.value })} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Senha *</label>
                    <input className="form-input" type="password" value={formAdmin.senha} onChange={e => setFormAdmin({ ...formAdmin, senha: e.target.value })} required />
                  </div>
                </div>
                <div className="modal-actions">
                  <button type="button" className="btn btn-secondary" onClick={() => setModalAdmin(false)}>Fechar</button>
                  <button type="submit" className="btn btn-primary" disabled={salvando}>{salvando ? 'Salvando...' : 'Adicionar Admin'}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
